import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SettingsSubNavStateService } from "@webapp/navigation/services/settings/settings-sub-nav-state.service";

@Component({
  selector: "gh-settings-sub-navigation",
  templateUrl: "./settings-sub-navigation.component.html",
})
export class SettingsSubNavigationComponent implements OnInit {
  @Output() private titleChange = new EventEmitter<string>();

  private sectionTitle = "Settings";

  constructor(public state: SettingsSubNavStateService) {}

  public ngOnInit(): void {
    this.titleChange.emit(this.sectionTitle);
  }
}
